var _defs, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToyki(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    zoomAndPan: "magnify",
    viewBox: "0 0 180 42.75",
    height: 57,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.74407, 30.918892)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.214844 -24.378906 L 0.214844 -18.515625 L 5.332031 -18.515625 L 5.332031 0 L 12.4375 0 L 12.4375 -18.515625 L 17.449219 -18.515625 L 17.449219 -24.378906 Z M 0.214844 -24.378906 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.907117, 30.918892)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 12.542969 -24.734375 C 5.332031 -24.734375 0.886719 -19.617188 0.886719 -12.117188 C 0.886719 -4.902344 5.4375 0.355469 12.542969 0.355469 C 19.722656 0.355469 24.199219 -4.941406 24.199219 -12.117188 C 24.199219 -19.582031 19.757812 -24.734375 12.542969 -24.734375 Z M 8.882812 -12.082031 C 8.882812 -16.773438 10.234375 -19.226562 12.542969 -19.226562 C 14.960938 -19.226562 16.203125 -16.667969 16.203125 -12.082031 C 16.203125 -7.355469 14.925781 -5.222656 12.542969 -5.222656 C 10.164062 -5.222656 8.882812 -7.355469 8.882812 -12.082031 Z M 8.882812 -12.082031 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(82.177043, 30.918892)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.0351562 -24.378906 L 8.246094 -10.304688 L 8.246094 0 L 15.496094 0 L 15.496094 -10.304688 L 23.132812 -24.378906 L 16.597656 -24.378906 L 12.507812 -16.347656 L 8.246094 -24.378906 Z M 0.0351562 -24.378906 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(105.025593, 30.918892)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.8125 -24.378906 L 1.8125 0 L 8.847656 0 L 8.847656 -5.652344 L 11.40625 -9.203125 L 15.601562 0 L 23.808594 0 L 16.167969 -15.457031 L 22.316406 -24.378906 L 15.601562 -24.378906 L 8.847656 -14.320312 L 8.847656 -24.378906 Z M 1.8125 -24.378906 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(127.874143, 30.918892)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.027344 -24.378906 L 2.027344 0 L 9.558594 0 L 9.558594 -24.378906 Z M 2.027344 -24.378906 "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToyki);
export default __webpack_public_path__ + "static/media/toyki.5a51066cc12031677b4b4932a08acd83.svg";
export { ForwardRef as ReactComponent };